import IPlayer from "../../../../../models/player.model";
import { socketActions } from "../../../../../store/socketSlice";
import { useAppDispatch, useAppSelector } from "../../../../../store/store";
import ActionIcon from "../../../../ui/action-icon/ActionIcon";
import Tooltip from "../../../../ui/tooltip/Tooltip";
import "./PlayerTable.scss";

const PlayerTable = () => {
  const players = useAppSelector((s) => s.game.playerList);
  const dispatch = useAppDispatch();

  const playerAction = (
    action: string,
    player: IPlayer,
    confirmation?: string
  ) => {
    if (confirmation) {
      const confirmed = window.confirm(confirmation);
      if (!confirmed) return;
    }
    dispatch(socketActions.sendMessage(`${action} ${player.name}`));
  };

  const killClosestAi = (player: IPlayer) => {
    const confirmed = window.confirm(
      `[EXPERIMENTAL] Are you sure you want to kill the closest AI for ${player.name}?`
    );
    if (!confirmed) return;

    dispatch(socketActions.sendMessage(`killClosestAi ${player.name}`));
  };

  const killClosestZombie = (player: IPlayer) => {
    const confirmed = window.confirm(
      `[EXPERIMENTAL] Are you sure you want to kill the closest Zombie for ${player.name}?`
    );
    if (!confirmed) return;

    dispatch(socketActions.sendMessage(`killClosestZombie ${player.name}`));
  };

  const followPlayer = (player: IPlayer) => {
    dispatch(socketActions.sendMessage(`followPlayer ${player.name}`));
  };

  return (
    <div className="player-table">
      <table>
        <thead>
          <tr>
            <th>Player name</th>
            <th>Humanity</th>
            <th>Unique Id</th>
            <th>Blood</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          {players.length > 0 &&
            players.map((p, i) => {
              return (
                <tr key={i}>
                  <td>{p.name}</td>
                  <td>{p.humanity}</td>
                  <td>{p.uuid}</td>
                  <td>{Math.round(p.blood)}</td>
                  <td className="action-column">
                    <Tooltip text="Spectates the player">
                      <ActionIcon
                        icon="fa-solid fa-arrows-to-eye"
                        onClick={() => playerAction("tv", p)}
                        disabled={!p.alive || p.blood == 0}
                      />
                    </Tooltip>{" "}
                    /
                    <Tooltip text="Locates the player on the map">
                      <ActionIcon
                        icon="fa-solid fa-location-dot"
                        onClick={() => followPlayer(p)}
                        disabled={!p.alive || p.blood == 0}
                      />
                    </Tooltip>{" "}
                    /
                    <Tooltip text="Kills the player (of blood loss)">
                      <ActionIcon
                        icon="fa-solid fa-person-falling-burst"
                        onClick={() =>
                          playerAction(
                            "killPlayer",
                            p,
                            `Are you sure you want to kill ${p.name}?`
                          )
                        }
                        disabled={!p.alive || p.blood == 0}
                      />
                    </Tooltip>{" "}
                    /
                    <Tooltip text="Explodes the vehicle of the player">
                      <ActionIcon
                      icon="fa-solid fa-car-burst"
                      onClick={() =>
                        playerAction(
                          "killTransport",
                          p,
                          `Are you sure you want to destroy ${p.name}'s vehicle?`
                        )
                      }
                      disabled={!p.isInVehicle || !p.alive || p.blood == 0}
                    />
                    </Tooltip>{" "}
                    /
                    <Tooltip text="Experimental: Kills the closest AI to the player.">
                      <ActionIcon
                        icon="fa-solid fa-gun"
                        onClick={() => killClosestAi(p)}
                        disabled={!p.alive || p.blood == 0}
                      />{" "}
                    </Tooltip>
                    /
                    <Tooltip text="Experimental: Kills the closest zombie to the player.">
                      <ActionIcon
                        icon="fa-solid fa-biohazard"
                        onClick={() => killClosestZombie(p)}
                        disabled={!p.alive || p.blood == 0}
                      />
                    </Tooltip>
                  </td>
                </tr>
              );
            })}
          {players.length === 0 && (
            <tr>
              <td colSpan={6} className="centered">
                No players were found.
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
};

export default PlayerTable;
